// leave constant here because if we want to change key
// we have to change on file 'public/handle-cordova.js' too
const IS_MLBILE_APP_LOCAL_STORAGE_KEY = "isMobileApp";

const isRunningOnMobileApp = () => {
  return localStorage.getItem(IS_MLBILE_APP_LOCAL_STORAGE_KEY) === "true";
};

export { isRunningOnMobileApp };
